const buildAssistantContextStorageKey = (channelId: string) =>
    `assistant-context-${channelId}`;

export const MAX_ASSISTANT_CONTEXT_IDS = 5;

const normalizeAssistantContextIds = (contextIds: string[]) =>
    Array.from(
        new Set(
            contextIds.filter(
                (contextId): contextId is string =>
                    typeof contextId === "string" && contextId.trim().length > 0
            )
        )
    ).slice(0, MAX_ASSISTANT_CONTEXT_IDS);

export const loadAssistantContextIds = (channelId: string): string[] => {
    if (!channelId || typeof window === "undefined") {
        return [];
    }

    try {
        const rawValue = window.localStorage.getItem(
            buildAssistantContextStorageKey(channelId)
        );

        if (!rawValue) {
            return [];
        }

        const parsedValue = JSON.parse(rawValue);

        if (!Array.isArray(parsedValue)) {
            return [];
        }

        return normalizeAssistantContextIds(parsedValue);
    } catch {
        return [];
    }
};

export const saveAssistantContextIds = (
    channelId: string,
    contextIds: string[]
): string[] => {
    const normalizedIds = normalizeAssistantContextIds(contextIds);

    if (!channelId || typeof window === "undefined") {
        return normalizedIds;
    }

    try {
        if (normalizedIds.length === 0) {
            window.localStorage.removeItem(
                buildAssistantContextStorageKey(channelId)
            );
            return normalizedIds;
        }

        window.localStorage.setItem(
            buildAssistantContextStorageKey(channelId),
            JSON.stringify(normalizedIds)
        );
    } catch {
        return normalizedIds;
    }

    return normalizedIds;
};
